<template>
  <div class="answerImageWrapper">
    <div class="answerImageBackground">
      <img @load="scrollToElement" class="answerImage" :src="answerImage" />
    </div>
    <p class="answerImageText">{{ answerText }}</p>
  </div>
</template>

<script>
import { scrollToElement } from "../assets/js/helper";
import { mapGetters } from "vuex";
export default {
  name: "AnswerImage",
  props: {
    answerImage: {
      type: String,
      required: true
    },
    answerText: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapGetters(["isOnFirstQuestion"]),
    scrollToElement() {
      if (!this.isOnFirstQuestion) {
        scrollToElement(this.$root.slider, {
          behavior: "smooth",
          block: "start"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.answerImageWrapper {
  .answerImageBackground {
    display: block;
    .answerImage {
      max-width: 100%;
      width: 100%;
      transition: all 0.32s;
      z-index: 3;
      display: block;
      position: relative;
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .answerImageText {
    font-weight: 700;
    margin: 0;
    margin-top: 5px;
    background: white;
    z-index: 999;
    position: relative;
    &:hover {
      color: #0b6a6e;
    }
  }
}

.hovered .answerImage {
  // transform: scale(1.1);
  z-index: 3;
  position: relative;
}
</style>
